import { CompanyList } from "../../../features/Company/CompanyList";

export function CompanyListPage(){

    return(
        <div>
            <CompanyList />
        </div>
    );
}